import { useEffect } from "react";
import { collectionRef } from "@/api/collectionRef/collectionOperations";
import { brand } from "branchAndBrandSpecific/utils/brandVariables/brandVariables";
import { useEventsStore } from "@/store/events/events.store";
import { Events } from "@/models/database/event/Events.model";

export const useTenantEvents = () => {
  const { events, loading, error, setEvents, setLoading, setError } =
    useEventsStore();

  const fetchEvents = async () => {
    try {
      setLoading(true);
      const eventsArray: Events[] = [];

      const ref = collectionRef.events(brand.tenantId);
      const query = await ref.get();

      // Get news from Firestore
      query.docs.map(async (doc) => {
        eventsArray.push(doc.data() as Events);
        return doc.data() as Events;
      });

      setEvents(eventsArray);
    } catch (error) {
      setError(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!events) {
      fetchEvents();
    }
  }, [brand.tenantId]);

  return {
    data: events,
    loading,
    error,
  };
};
